import * as L from 'leaflet';

export const Leaflet = L;
